import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const [isAuthentication, setIsAuthentication] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user")) || {};
    setIsAuthentication(user?.success);
    setIsLoading(false); // Set loading to false after authentication check
  }, []);

  if (isLoading) {
    return null; // Render nothing while still loading
  }

  if (!isAuthentication) {
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
